import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Col, Row, Statistic, Tag, Typography } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import { DashboardCardContainer } from "src/app/features/Dashboard/utils/dashboardStyles";
import { Palette } from "../../../../core/styles/palette";
import type { SystemHealthDto } from "../types/Dashboard";
import { formatUptime } from "../utils/formatters";

const { Text } = Typography;

interface SystemHealthCardProps {
    health: SystemHealthDto;
}

/**
 * SystemHealthCard - Displays system health metrics
 */
export const SystemHealthCard: FC<SystemHealthCardProps> = ({ health }) => {
    return (
        <DashboardCardContainer title={i18n.t("dashboard.systemHealth")}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Statistic
                        title={i18n.t("dashboard.systemUptime")}
                        value={formatUptime(health.uptimeSeconds)}
                        prefix={<ClockCircleOutlined />}
                        styles={{ content: { color: Palette.HeroGreen, fontSize: 16 } }}
                    />
                </Col>
                <Col span={12}>
                    <div>
                        <Text type="secondary" style={{ display: "block", marginBottom: 8 }}>
                            Database Connection
                        </Text>
                        {health.databaseConnectionHealthy ? (
                            <Tag icon={<CheckCircleOutlined />} color={Palette.HeroGreen}>
                                Healthy
                            </Tag>
                        ) : (
                            <Tag icon={<CloseCircleOutlined />} color={Palette.AeviRed}>
                                Unhealthy
                            </Tag>
                        )}
                    </div>
                </Col>
                <Col span={12}>
                    <Statistic
                        title={i18n.t("dashboard.activeThreads")}
                        value={health.threadCount}
                        styles={{ content: { fontSize: 20 } }}
                    />
                </Col>
                <Col span={12}>
                    <Statistic
                        title={i18n.t("dashboard.totalThreadsStarted")}
                        value={health.totalStartedThreadCount}
                        styles={{ content: { fontSize: 20 } }}
                    />
                </Col>
            </Row>
        </DashboardCardContainer>
    );
};
